export default {
  cancelText: 'Avbryt',
};
